import { render, staticRenderFns } from "./ConfirmRadioGroup.vue?vue&type=template&id=7c6c626b&scoped=true&"
import script from "./ConfirmRadioGroup.vue?vue&type=script&lang=js&"
export * from "./ConfirmRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRadioGroup.vue?vue&type=style&index=0&id=7c6c626b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c626b",
  null
  
)

export default component.exports